module.exports = __webpack_public_path__ + "img/styles2.28450752.png";